/**
 * Headless wording for the supplier pages.
 *
 * Where a supplier's account stands (its position and health) is the composed
 * views' (`/views/suppliers`, `/views/supplier/{no}`), from the same bases as
 * the invoice queue and the open purchase orders, so it is not re-derived here.
 */

import type { SupplierStatus } from "../data/purchase-ledger-types";

export const SUPPLIER_STATUS_LABELS: Record<SupplierStatus, string> = {
  active: "Active",
  on_hold: "On hold",
  closed: "Closed",
};
